<template>
  <div>
    <el-row :gutter="12">
      <el-col :span="6">
        <el-card shadow="hover" body-style="text-align: center" v-loading="statLoading">
          <h1>{{ stat.price_total }}</h1>
          <h3>应收金额</h3>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover" body-style="text-align: center" v-loading="statLoading">
          <h1>{{ stat.price_collection }}</h1>
          <h3>实收金额</h3>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover" body-style="text-align: center" v-loading="statLoading">
          <h1>{{ stat.price_surplus }}</h1>
          <h3>待收金额</h3>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover" body-style="text-align: center" v-loading="listLoading">
          <h1>{{listTotal}}</h1>
          <h3>总订单数</h3>
        </el-card>
      </el-col>
    </el-row>
    <el-row style="margin-top: 10px">
      <el-select v-model="query.course_id" placeholder="请选择课程" size="small" style="margin-right: 10px">
        <el-option label="全部课程" value="0">
        </el-option>
        <el-option
            v-for="item in courseList"
            :key="item.id"
            :label="item.title"
            :value="item.id">
        </el-option>
      </el-select>
      <el-select v-model="query.order_status" placeholder="请选择订单状态" size="small" style="margin-right: 10px">
        <el-option label="全部订单" value=""></el-option>
        <el-option label="待支付" value="1"></el-option>
        <el-option label="支付中" value="6"></el-option>
        <el-option label="已支付" value="2"></el-option>
      </el-select>
      <el-date-picker
          v-model="query.begin_at"
          align="right"
          type="date"
          placeholder="选择开始时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          size="small"
          style="margin-right: 10px"
      >
      </el-date-picker>
      <el-date-picker
          v-model="query.end_at"
          align="right"
          type="date"
          placeholder="选择结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          size="small"
      >
      </el-date-picker>
      <el-button type="primary" size="small" @click="getList(1)" :loading="listLoading">
        查询
      </el-button>
      <el-button type="primary" size="small" @click="exportMeetActivityOrder()" :loading="exportLoading">
        导出
      </el-button>
    </el-row>
    <el-row>
      <el-table :data="listData" style="width: 100%" border size="mini" v-loading="listLoading">
        <el-table-column prop="order_no" label="订单编号" width="180" fixed></el-table-column>
        <el-table-column prop="status_msg" label="订单状态" width="70"></el-table-column>
        <el-table-column prop="payment_method" label="支付方式"></el-table-column>
        <el-table-column prop="platform" label="订单来源"></el-table-column>
        <el-table-column prop="body" label="课程名称" width="220" show-overflow-tooltip fixed></el-table-column>
        <el-table-column prop="total_amount" label="应收金额"></el-table-column>
        <el-table-column prop="price_collection" label="实收金额"></el-table-column>
        <el-table-column prop="price_surplus" label="待收金额"></el-table-column>
        <el-table-column prop="created_at" label="创建时间" width="140"></el-table-column>
        <el-table-column prop="paid_at" label="完成时间" width="140"></el-table-column>
        <el-table-column prop="nickname" label="用户昵称" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="mobile_phone" label="用户手机" width="100"></el-table-column>
        <el-table-column prop="student_name" label="学员姓名" width="70"></el-table-column>
        <el-table-column prop="student_identity" label="学员身份"></el-table-column>
        <el-table-column prop="student_mobile" label="学员手机" width="100"></el-table-column>

        <el-table-column
            label="学员地域"
            align="center"
        >
          <template slot-scope="{ row }">
              <div v-if="row.region_display_status">{{ row.region_name }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="student_belong_to" label="流量归属" width="70"></el-table-column>
        <el-table-column prop="student_assistant" label="助教" width="120"></el-table-column>
        <el-table-column prop="student_group" label="组别" width="70"></el-table-column>

      </el-table>

      <div style="margin-top:10px">
        <el-pagination background @current-change="getList(0)" :current-page.sync="query.page"
                       :page-size="query.limit"
                       layout="total, prev, pager, next, jumper" :total="listTotal">
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>

<script>
import {
  getMeetActivityOrderList, getMeetActivityCourseList, getMeetActivityStat, exportMeetActivityOrder
} from "@/api/activity";

export default {
  data: function () {
    return {
      listData: [],
      listLoading: false,
      listTotal: 0,
      courseList: [],
      statLoading: false,
      exportLoading: false,
      stat:{
        price_total: '0.00',
        price_collection: '0.00',
        price_surplus: '0.00',
      },
      query: {
        begin_at:'',
        end_at:'',
        course_id: '0',
        order_status: '',
        activity_id: 0,
        limit: 10,
        page: 1
      }
    }
  },
  created: function () {
    this.query.activity_id = this.$route.query.activity_id;
    this.getMeetActivityCourseList();
  },
  methods: {
    getList(loadingStat) {
      this.listLoading = true;
      getMeetActivityOrderList(this.query).then(response => {
        this.listData = response.data.list
        this.listTotal = response.data.total
        this.listLoading = false;
      });
      if(loadingStat == 1){
        this.getMeetActivityStat();
      }
    },
    getMeetActivityCourseList() {
      getMeetActivityCourseList({
        activity_id: this.query.activity_id
      }).then(response => {
        this.courseList = response.data.list
        this.query.begin_at = response.data.info.start_at
        this.query.end_at = response.data.info.end_at
        this.getList(1);
      });
    },
    getMeetActivityStat(){
      this.statLoading = true
      getMeetActivityStat(this.query).then(response => {
        this.stat.price_total = response.data.price_total
        this.stat.price_collection = response.data.price_collection
        this.stat.price_surplus = response.data.price_surplus
        this.statLoading = false;
      });
    },
    exportMeetActivityOrder(){
      this.exportLoading = true;
      exportMeetActivityOrder(this.query).then(response => {
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'orders.xlsx');
        document.body.appendChild(link);
        link.click();
        this.exportLoading = false;
      })
    },
  },
}
</script>
<style>
.el-button {
  margin-left: 10px;
  margin-bottom: 10px;
}
</style>